if (!customElements.get('background-video')) {
  class BackgroundVideo extends HTMLElement {
    constructor() {
      super();
      this.tl = false;
      this.splittext = false;
    }
    
    connectedCallback() {
      const videoElement = this.querySelector('video.background-video');
      if (videoElement) {
        videoElement.setAttribute('loop', '');
        videoElement.setAttribute('autoplay', '');
        videoElement.setAttribute('muted', '');
        videoElement.setAttribute('playsinline', '');
        
        videoElement.addEventListener('ended', function() {
          this.currentTime = 0;
          this.play();
        }, false);

        videoElement.play().catch(error => {
          console.log('Error al reproducir el video:', error);
        });
      }
      

      let video_container = this.querySelector('.background-video__iframe');
      if (video_container) {
        if (video_container.querySelector('iframe')) {
          video_container.querySelector('iframe').onload = () => {
            this.videoPlay(video_container);
          };
        }
      }
    }
    
    videoPlay(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'youtube') {

          video_container.querySelector('iframe').contentWindow.postMessage(
            JSON.stringify({ 
              event: "command", 
              func: "playVideo", 
              args: "" 
            }), 
            "*"
          );
          video_container.querySelector('iframe').contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "setLoop",
              args: [true]
            }),
            "*"
          );
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(
            JSON.stringify({ 
              method: "play" 
            }), 
            "*"
          );
          
          video_container.querySelector('iframe').contentWindow.postMessage(
            JSON.stringify({ 
              method: "setLoop",
              value: true
            }), 
            "*"
          );
        }
      }, 10);
    }
  }
  customElements.define('background-video', BackgroundVideo);
}